import React, { FunctionComponent } from "react";

export const Footer: FunctionComponent = () => (
  <footer className="w-full px-6 py-4 text-center bg-green-100 border-t-4 border-green-600">
    28, Jalan TP 3/2, Sime UEP Industrial Park, 47600,
    <br />
    Subang Jaya, Selangor Darul Ehsan, Malaysia
    <br />
    <div className="pt-2 text-sm font-semibold text-gray-600">
      Copyright © {new Date().getFullYear()} by Eco-Orion
    </div>
  </footer>
);
